import React from 'react';
import ErrorMessage from '../formFields/ErrorMessage';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import EyeIcon from '../icons/EyeIcon';
import EyeSlashIcon from '../icons/EyeSlashIcon';

export default function AuthPasswordField({
  errors,
  id,
  name,
}: {
  errors: string[] | undefined;
  id: string;
  name: string;
}) {
  const [isPasswordViewable, setIsPasswordViewable] = React.useState(false);
  return (
    <>
      <div className="relative flex w-full flex-col items-start justify-center">
        <Label htmlFor={id} className="pb-2">
          Password
        </Label>
        <Input
          type={isPasswordViewable ? 'text' : 'password'}
          placeholder="Enter your password"
          name={name}
          className="mb-4 w-full"
          id={id}
        />
        <button
          className="absolute right-2 top-1 h-full px-2"
          onClick={() => setIsPasswordViewable(!isPasswordViewable)}
          type="button"
        >
          {isPasswordViewable ? <EyeIcon /> : <EyeSlashIcon />}
        </button>
      </div>
      {errors?.map((error) => <ErrorMessage className="my-0 mb-4 w-full" key={error} error={error} />)}
    </>
  );
}
